import React, { useState, useEffect } from 'react';
import { Container, Form, FormGroup, Col, Button, Input, Alert } from 'reactstrap';
import { useDispatch, useSelector } from 'react-redux';
import { FaEquals } from 'react-icons/fa';
import { generateReport } from '../../../actions/users';
import { Loading } from '../../../loader/Loading';
import DocumentTitle from 'react-document-title';

const SearchCriteria = props => {
  const [attribute_name, setAttributeName] = useState('');
  const [attribute_value, setAttributeValue] = useState('');
  const dispatch = useDispatch();
  let { isLoading } = useSelector(store => store.fetch);
  let { error_obj } = useSelector(store => store.error);
  let { report } = useSelector(store => store.users);
  const options = [
    { value: '', label: 'Select the criteria' },
    { value: 'status', label: 'Status' },
    { value: 'name', label: 'Company Name' },
    { value: 'role', label: 'Role' },
    { value: 'sapaccountid', label: 'SAP Account ID' }
  ];

  const statusList = [
    { value: '', label: 'Select the status' },
    { value: 'Enabled', label: 'Enabled' },
    { value: 'Disabled', label: 'Disabled' }
  ];
  const optionList = options => {
    return options.map((opt, i) => {
      return (
        <option value={opt.value} key={i}>
          {opt.label}
        </option>
      );
    });
  };
  const handleSubmit = e => {
    e.preventDefault();
    dispatch({ type: 'SET_ERROR', data: { error_obj: undefined } });
    dispatch(generateReport(attribute_name, attribute_value));
  };

  const cleanUp = () => {
    dispatch({ type: 'SET_GENERATE_REPORT', data: { report: undefined } });
    dispatch({ type: 'SET_ERROR', data: { error: undefined } });
  };

  useEffect(() => {
    return () => {
      dispatch({ type: 'SET_GENERATE_REPORT', data: { report: undefined } });
      dispatch({ type: 'SET_ERROR', data: { error: undefined } });
    };
  }, [dispatch]);

  return (
    <>
      <DocumentTitle title={`Doorkeeper | Generate Report`}></DocumentTitle>
      <Container>
        <h5 style={{ marginLeft: '42%' }}>Generate Report</h5>

        <Container
          style={{
            border: '3px solid #ddd',
            padding: '1% 3%'
          }}
        >
          {' '}
          {isLoading && <Loading />}
          <Form onSubmit={handleSubmit}>
            <FormGroup row style={{ margin: '0 0 0 0' }}>
              <Col sm="4">
                <Input
                  type="select"
                  name="attribute_name"
                  value={attribute_name}
                  onChange={e => {
                    setAttributeName(e.target.value);
                    cleanUp();
                  }}
                >
                  {optionList(options)}
                </Input>
              </Col>
              <Col sm="1">
                <span
                  style={{
                    fontSize: '20px',
                    marginLeft: '25%'
                  }}
                >
                  <FaEquals />
                </span>
              </Col>
              {attribute_name === 'status' ? (
                <Col sm="4">
                  <Input
                    type={'select'}
                    name="attribute_value"
                    value={attribute_value}
                    onChange={e => {
                      setAttributeValue(e.target.value);
                      cleanUp();
                    }}
                  >
                    {' '}
                    {optionList(statusList)}
                  </Input>
                </Col>
              ) : (
                <Col sm="4">
                  <Input
                    type={'text'}
                    name="attribute_value"
                    value={attribute_value}
                    onChange={e => {
                      setAttributeValue(e.target.value);
                      cleanUp();
                    }}
                  />
                </Col>
              )}

              <Col sm="2">
                <Button
                  style={{ float: 'left' }}
                  type="submit"
                  disabled={!attribute_value || !attribute_name}
                  onClick={() => {
                    cleanUp();
                  }}
                >
                  Search
                </Button>
              </Col>
            </FormGroup>
          </Form>
        </Container>
        {report && !error_obj && (
          <Alert color="success" style={{ textAlign: 'center' }}>
            <h6>{report}</h6>
          </Alert>
        )}

        {error_obj && (
          <Alert color="danger" style={{ textAlign: 'center' }}>
            <h6>{'System error occured. Please contact system administrator'}</h6>
          </Alert>
        )}
      </Container>
    </>
  );
};

export default SearchCriteria;
